<template>
    <div class="main">
        <Steps :index="0" product-name="定制-建工雇主责任险按项目方案" />
        <Applicant :info="info.companyVO" :formInfo="form" @on-change="setApplicantData" @on-changeCost="changeCost" ref="applicant" title="投保企业信息" />
        <Recognize ref="recognize" :info="info" :formInfo="form" @set-amount="setAmount" />
        <Invoice :info="info.invoice" :formInfo="form" ref="invoice" class="mt20" />
        <div class="mt20 center">
            <!--  <p>投保时间：1年</p>
            <p>投保方案：</p> -->
            <p>总费用：<span class="price">{{ amount }}元</span></p>
            <p class="mt10">
                <!-- :loading="loading" -->
                <Button type="primary" @click="sub" :loading="loading">立即投保</Button>
            </p>
        </div>
    </div>
</template>
<script>
import Steps from '../common/Steps'
import Recognize from './Recognize'
import RecognizeCompany from './RecognizeCompany'
import Applicant from './common/Applicant'
import ApplicantCompany from './common/ApplicantCompany'
import Invoice from './common/Invoice'
import { mapState } from 'vuex'
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
export default {
    mixins:[ track ],
    components: { Steps, Recognize, Applicant, Invoice,RecognizeCompany,ApplicantCompany,TrackNotice },
    data() {
        return {
            info: {
                recognize: {
                    insuredPeriod: '12',
                    subjoinAllDay: false,
                    subjoinOwnMedicine: false,
                    subjoinProportionAdj: false
                },
                companyVO: {},
                invoice: {
                    invoiceType: 'PLAIN'
                },
                applicantList:[],
                productCode: this.$route.query.productCode || 'QYTTGZZRXPCNEW'
            },
            form: {},
            amount: '',
            loading: false,
            id: this.$route.query.id,
            isRenew: this.$route.query.renew || '',
            detail: {}
        }
    },
    computed: {
        ...mapState({
            userInfo: state => state.common.info
        })
    },
    watch: {
        userInfo() {
            this.checkLogin()
        }
    },
    created() {
        if (this.checkLogin && this.id) {
            this.getInfo()
        }
        //获取单点登录信息
        this.getSsoInfo()
    },
    mounted(){
		// 重新投保
		if(this.id&&this.isRenew){
			this.track_is_new = true;
			this.$nextTick(()=>{
				this.trackInit();
			})
		} else {
			// 回溯 开始录制
			this.$nextTick(this.startRecord);
		}
	},
    methods: {
        //获取单点登录信息
        getSsoInfo() {
            this.$axios.post("/employerLiability/getFlexibleEmpPlat").then(res => {
                if (res) {
                    this.info.companyVO = {
                        ...res,
                        organizationCode: res.unifiedSocialCreditCode
                    }
                }
            })
        },
        checkLogin() {
            // 检测登录
            if (!this.userInfo.userId) {
                if (location.href && location.href.indexOf('/common.html#/login') == -1) {
                    window.location = location.origin + '/common.html#/login?bankUrl=' + encodeURIComponent(location.href);
                }
                return false
            } else {
                return true
            }
        },
        // 根据id获取信息
        async getInfo() {
            let obj = {}
            let url = ''
            if (this.taskName || this.taskId) { // 通过工作台审批流进入
                obj.applicationNo = this.$route.query.id
                url = '/broker/insurance/application/detailByApplicationNo.admin'
            } else {
                obj.applicationId = this.$route.query.id
                url = '/broker/insurance/application/detail.admin'
            }
            let res = await this.$axios.post(url, obj)
            this.form = res
            this.detail = res
            this.form.url = []
            if (this.form.extraInfo.businessLicenseUrl) {
                this.form.url = this.form.extraInfo.businessLicenseUrl.split(",")
            }
            this.form.url_ = []
            if (this.form.extraInfo.projectContract) {
                this.form.url_ = this.form.extraInfo.projectContract.split(",")
            }
        },
        // 校验
        async sub() {
            let applicant = await this.$refs.applicant.val();
            let recognize = await this.$refs.recognize.val();
            console.log('zouha de ')
            let invoice = await this.$refs.invoice.val();
            if (!applicant) {
                this.toast('投保企业信息校验失败', 'error');
                return;
            }
            let fistPart = this.$refs.applicant.form
            let appObj = {}
            this.form = {
                ...fistPart,
            }
            appObj.subjectName = fistPart.companyName
            appObj.subjectType = 'APPLICANT'
            this.form.applicantName=fistPart.companyName
            appObj.idNumber = fistPart.idNumber
            this.form.applicantList = []
            this.form.applicantList.push(appObj)  //投保人列表
            let insObj = {}
            insObj.contactPhone = fistPart.contactsPhone
            insObj.subjectName = fistPart.insName
            insObj.areaCode = fistPart.areaCode
            insObj.address = fistPart.insDEtAdd  //详细地址
            insObj.fullAddress = fistPart.insDEtAdd
            insObj.zipCode = fistPart.insEmail
            insObj.subjectType = 'INSURED'
            this.form.insuredList = []
            this.form.insuredList.push(insObj)  //被保人列表
            if (!recognize) {
                return;
            }
            if (!invoice) {
                this.toast('发票信息校验失败', 'error');
                return;
            }
            this.loading = true;
            this.form = {
                ...this.form,
                invoiceInfo: {
                    ...invoice,
                },
                extraInfo: {
                    ...this.form,
                    ...recognize,
                    overallArea: 2000,
                    workersNumber: 100,
                    safetyHazard: '无',
                    safetyMark: '齐全有效',
                    disputeResolution: '诉讼'

                },
                ...recognize,
                premium: this.amount,
                bizId: "JIANGONG_EMPLOYER_LIABILITY",
                insuranceType: 'NEW'
            }
            if (this.$route.query.id) {
                this.form.insuranceApplicationId = this.$route.query.id
                this.form.insuredList[0].id = this.detail.insuredList[0].id
                this.form.applicantList[0].id = this.detail.applicantList[0].id,
                this.form.applicationNo = this.detail.applicationNo
            }
            this.$axios.post(`/broker/insurance/application/apply.json.all`, this.form).then(async res => {
                this.loading = false;
                if (res.code == 10000000) {
                    // 回溯 停止录制
					await this.stopRecord({
						session_key:sessionStorage.track_session_key,
						policy_id:res.msg||''
					});
                    this.toast('提交成功')
                    this.$router.replace(`/customized-employer-liability/confirm/${res.data}?productCode=${recognize.productCode}`)
                } else {
                    this.alert(res.msg)
                }
            }).catch(res=>{
                this.loading = false;
            })
            // this.$router.replace(`/customized-employer-liability/confirm?productCode=${recognize.productCode}`)
            // this.$axios.post('/employerLiability/buyingInsurance.json.all', {
            //     companyVO: {
            //         ...applicant,
            //         ...invoice
            //     },
            //     employerTotalAmountVO: recognize.employerTotalAmountVO,
            //     importEmployeeVOS: recognize.importEmployeeVOS,
            //     invoiceType: invoice.invoiceType,
            // }).then(res => {
            //     this.loading = false;
            //     if (res.code == 10000000) {
            //         if (!this.id || res.data != this.id) {
            //             this.$router.replace(`/company-group-employer/fillin/${res.data}?productCode=${this.info.productCode}`)
            //         }
            //         this.$router.push('/company-group-employer/confirm/' + res.data);
            //     } else {
            //         this.alert(res.msg)
            //     }
            // });
        },
        // 设置总费用
        setAmount(amount) {
            this.amount = amount;
        },
        // 同步投保公司数据，用于更新公司名称和社会代码，开票组件会用到
        setApplicantData(form) {
            this.$set(this.info, 'invoice', {
                ...this.info.invoice,
                ...form
            })
            this.$set(this.info, 'projectDateEnd', form.projectDateEnd)
            console.log('xiugai时间fillin', this.info.projectDateEnd)
        },
        changeCost(val) {
            this.$set(this.info, 'projectCost', val)
            this.$refs.recognize.getPremium()
        },
    }
}
</script>
<style scoped>
.main {
    margin-top: 15px;
    padding: 30px 40px;
}

.mt20 {
    font-size: 25px;
    line-height: 1.8;
}

span.price {
    color: #FF0000;
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/Fillin.vue